<template>
  <section>
    <div class="popups">
      <EditBillingEntryModal
        v-model="showEditBillingEntryPopup"
        :entry="editBillingEntryItem"
        @saved="OnBillingEntrySaved"
      />

      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <b-row>
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>

              <div class="col-auto text-right">
                <b-button
                  type="reset"
                  variant="outline-danger"
                  @click="resetFormFilters()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="
                    showFilters = false;
                    formFilters = { ...itemsFilters };
                  "
                >
                  Cancel
                </b-button>
              </div>
            </b-row>
          </div>

          <div class="px-3 py-2">
           <b-form-group label="Client:">
              <b-v-select
                v-model="formFilters.brandId"
                :searchable="true"
                :options="brandsFilter"
              />
            </b-form-group>
           <b-form-group label="Warehouse:" description="Note for Surcharges: If referenced entity, could not be found in system (Type: Other), warehouse is not applied.">
              <b-v-select
                v-model="formFilters.warehouseId"
                :searchable="true"
                :options="warehousesFilter"
              />
            </b-form-group>
            <b-form-group label="References:">
              <b-form-input v-model="formFilters.referenceNumber" />
            </b-form-group>
            <b-form-group label="Tracking Number:">
              <b-form-input v-model="formFilters.trackingNumber" />
            </b-form-group>
             <b-form-group label="Charge Type:">
              <b-v-select
                v-model="formFilters.chargeType"
                :searchable="true"
                :options="chargeTypeFilter"
              />
            </b-form-group>
            <b-form-group label="Search Label:">
              <b-form-input v-model="formFilters.chargeLabel" />
            </b-form-group>
             <b-form-group label="Entity Type:">
              <b-v-select
                v-model="formFilters.relatedEntityType"
                :searchable="true"
                :options="typesFilter"
              />
            </b-form-group>

            <b-form-group
              label="From Charged Date:"
              description="From Date must be before To Date"
            >
              <b-form-datepicker
                :reset-button="true"
                v-model="formFilters.startDate"
                class="form-control flatpickr-input"
                placeholder="Select date"
                name="orderDateStart"

              />
            </b-form-group>
            <b-form-group  class="border-bottom mb-1 pb-2"  label="To Charged Date:">
              <b-form-datepicker
                :reset-button="true"
                v-model="formFilters.endDate"
                class="form-control flatpickr-input"
                placeholder="Select date"
                name="orderDateEnd"

              />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>

    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h1 class="header-title">
              Carrier Charges
            </h1>
            <ActiveFiltersCard :itemsFilters="itemsFilters" :resetFilterWithKey="resetFilterWithKey" :loadItems="loadItems">
              <template v-slot:filterVal(projectId)="data">
                <span
                  v-if="myProjects && myProjects.find(a => a.id == data.item)"
                  >{{ myProjects.find(a => a.id == data.item).name }}</span
                >
                <span v-else>-</span>
              </template>
              <template v-slot:filterVal(brandId)="data">
                <span
                  v-if="myBrands && myBrands.find(a => a.id == data.item)"
                  >{{ myBrands.find(a => a.id == data.item).name }}</span
                >
                <span v-else>-</span>
              </template>
              <template v-slot:filterVal(warehouseId)="data">
                <span
                  v-if="myWarehouses && myWarehouses.find(a => a.id == data.item)"
                  >{{ myWarehouses.find(a => a.id == data.item).name }}</span
                >
                <span v-else>-</span>
              </template>
            </ActiveFiltersCard>
          </div>
          <div class="col-auto">
            <b-button variant="warning" class="mr-2" v-if="IsFilteringRelatedEntity()" :to="getRelatedEntityUrl()">
              <i class="fa fa-eye mr-2"></i>
              View Client Billing Ledger for Entity
            </b-button>
            <b-button variant="primary" @click="showFilters = !showFilters">
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :loading-page="loadingItems"
      :failed-loading="failedLoadItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >
      <template v-slot:cell(shipDateTimeUtc)="data">
        <span
          v-if="
            data.item.shipDateTimeUtc &&
              !data.item.shipDateTimeUtc.endsWith('Z')
          "
          >{{
            (data.item.shipDateTimeUtc + 'Z') | moment('MMM Do YY, h:mm a')
          }}</span
        >
        <span v-else-if="data.item.shipDateTimeUtc">{{
          data.item.shipDateTimeUtc | moment('MMM Do YY, h:mm a')
        }}</span>
      </template>
      <template v-slot:cell(processedOn)="data">
        <span
          v-if="
            data.item.processedOn &&
              !data.item.processedOn.endsWith('Z')
          "
          >{{
            (data.item.processedOn + 'Z') | moment('MMM Do YY, h:mm a')
          }}</span
        >
        <span v-else-if="data.item.processedOn">{{
          data.item.processedOn | moment('MMM Do YY, h:mm a')
        }}</span>
      </template>
      <template v-slot:cell(id)="data">
        <div>
          <b-button
            v-if="data.item.needsReview"
            v-b-tooltip.hover.top="'Confirm as is'"
            class="btn-sml"
            variant="success"
            title="Confirm as is"
            @click="ConfirmAndSaveItemBrandInvoice(data.item)"
          >
          <i class="fa fa-check"></i>
          </b-button>
          <b-button
            v-else-if="data.item.comment"
            v-b-tooltip.hover.left="data.item.comment"
            class="btn-sml"
            variant="info"
            :title="data.item.comment"
          >
          <i class="fa fa-info"></i>
          </b-button>
          <b-button
            v-if="data.item.status == 'Processed'"
            v-b-popover.hover="'Was forwarded directly to client, and invoiced.'"
            class="btn-sml"
            variant="primary"
            :to="{
              name: 'Billing.CustomerBillingLedger.Index',
              query: { carrierBillingEntryId: data.item.id }
            }"
            title="View Charge"
          >
            <i class="fa fa-eye"></i>
          </b-button>
          <b-button
            v-else-if="data.item.status == 'Skipped'"
            v-b-tooltip.hover.left="'Skipped. Was not forwarded to client invoices.'"
            class="btn-sml"
            variant="secondary"
            title="Skipped. Was not forwarded to client invoices."
          >
            <i class="fa fa-eye"></i>
          </b-button>
          <b-button
            v-else-if="data.item.status == 'Error'"
            v-b-tooltip.hover.left="'Was not forwarded to client invoices, but should have, an error occurred.'"
            class="btn-sml"
            variant="danger"
            title="Was not forwarded to client invoices, but should have, an error occurred."
          >
            <i class="fa fa-eye"></i>
          </b-button>
          <b-button
            v-else
            v-b-tooltip.hover.left="'Unknown Charge. Was not forwarded to client invoices.'"
            class="btn-sml"
            variant="secondary"
            title="Unknown Charge.Was not forwarded to client invoices."
          >
            <i class="fa fa-eye"></i>
          </b-button>
        </div>
      </template>
      <template v-slot:cell(brandId)="data">
        <span
          v-if="myBrands && myBrands.find(a => a.id == data.item.brandId)"
          >{{ myBrands.find(a => a.id == data.item.brandId).name }}</span
        >
        <span v-else>N / A</span>
      </template>
      <template v-slot:cell(referenceNumber)="data">
        <div v-if="data.item.referenceNumber && data.item.relatedEntityType == 'Other'" >
          <span class="badge badge-info">
            REF 1: <span>{{ data.item.referenceNumber }}</span>
          </span>
        </div>
        <div v-if="data.item.referenceNumber2" >
          <span class="badge badge-secondary">
            REF 2: <span>{{ data.item.referenceNumber2 }}</span>
          </span>
        </div>
        <div v-if="data.item.referenceNumber3" >
          <span class="badge badge-dark">
            REF 3: <span>{{ data.item.referenceNumber3 }}</span>
          </span>
        </div>
      </template>
      <template v-slot:cell(relatedInfo)="data">
        <BillingCarrierRelatedInfoBadge :related-info="data.item"></BillingCarrierRelatedInfoBadge>
      </template>
      <template v-slot:cell(singleUnitCharge)="data">
        <div>
          <BillingChargeAmount :charge-amount="data.item.singleUnitCharge" :charge-currency="data.item.currency"></BillingChargeAmount>
          <div v-if="data.item.comment" v-b-tooltip.hover="data.item.comment">
            <i class="fa fa-commenting-o"></i>
          </div>
        </div>
      </template>
      <template v-slot:cell(lineItemOtherTotal)="data">
        <span v-b-tooltip.hover.bottom="'Includes Other charges on top of per unit charges. For Freight Type Charges that can be fuel, and such.'">
          <BillingChargeAmount :charge-amount="data.item.lineItemOtherTotal" :charge-currency="data.item.currency"></BillingChargeAmount>
        </span>
      </template>
      <template v-slot:cell(lineItemTotal)="data">
        <span v-if="data.item.comment" v-b-tooltip.hover.bottom="data.item.comment" class="badge" :class="{'badge-info': data.item.rateCardItemId, 'badge-danger': data.item.needsReview}">
          <BillingChargeAmount :charge-amount="data.item.lineItemTotal" :charge-currency="data.item.currency"></BillingChargeAmount>
        </span>
        <span v-else><BillingChargeAmount :charge-amount="data.item.lineItemTotal" :charge-currency="data.item.currency"></BillingChargeAmount></span>
      </template>
      <template v-slot:cell(chargeDescription)="data">
        <div class="d-inline-block small mr-1 px-1 rounded bg-primary" v-b-tooltip.hover.top="'Tracking Number: '+(data.item.trackingNumber ? data.item.trackingNumber : '-')" v-if="data.item.trackingNumber"><i class="fa fa-dropbox "></i></div>
        <div class="d-inline-block small mr-1 px-1 rounded bg-info" v-b-tooltip.hover.top="'Unit: '+(data.item.unitLabel ? data.item.unitLabel : '')" v-if="data.item.unitLabel && data.item.unitLabel != '-'"><i class="fa fa-tag"></i></div>
        <span v-if="!data.item.zoneId">{{ (data.item.chargeDescription ? data.item.chargeDescription : ' NONE ')}}</span>
        <u v-else v-b-tooltip.hover.bottom="'ZoneId: [' + data.item.zoneId + '] and Weight: [' + data.item.weight +']'">{{ (data.item.chargeDescription? data.item.chargeDescription : ' NONE ')}}</u>
      </template>

      <template v-slot:cell(type)="data">
        <div>
          <span class="badge badge-warning" v-if="data.item.type == 'StorefrontOrder'">Storefront Order</span>
          <span class="badge badge-info" v-else-if="data.item.type == 'SmallParcelShipment'">Small Parcel Shipment</span>
          <span class="badge badge-primary" v-else-if="data.item.type == 'BulkShipment'">Bulk Shipment</span>
          <span class="badge badge-primary" v-else-if="data.item.type == 'WarehouseShipment'">Warehouse Shipment</span>
          <span class="badge badge-primary" v-else-if="data.item.type == 'WorkOrder'">Work Order</span>
          <span class="badge badge-primary" v-else-if="data.item.type == 'OrderReturn'">Order Return</span>
          <span class="badge badge-primary" v-else-if="data.item.type == 'DirectInventoryUpdate'">Adjustment</span>
          <span class="badge badge-secondary" v-else>Unknown</span>
        </div>

      </template>
      <template v-slot:cell(orderNumber)="data">
        <div v-b-tooltip.hover.left="'Shipped with Carrier: [' + data.item.carrier + '] and Service: [' + data.item.service +']'">
          <span class="badge badge-warning" v-if="data.item.type == 'StorefrontOrder'">
            <router-link :to="{name: 'Common.OrderDetails', query: {
              id: data.item.orderId
            }}">{{ data.item.orderNumber }}</router-link>
          </span>
          <span class="badge badge-info" v-else-if="data.item.type == 'OrderReturn'">
            <router-link :to="{
            name: 'Storefronts.OrderReturns.Edit',
            params: { orderReturnId: data.item.orderReturnId }
            }">{{ data.item.orderNumber }}</router-link>
          </span>
          <span class="badge badge-info" v-else-if="data.item.type == 'SmallParcelShipment'">
            <router-link :to="{
              name: 'Warehouses.ManualShipments.Edit',
              params: { id: data.item.manualShipmentId }
            }">{{ data.item.orderNumber }}</router-link>
          </span>
          <span class="badge badge-primary" v-else-if="data.item.type == 'BulkShipment'">
            <router-link class="text-white" :to="{
              name: 'Warehouses.BulkShipments.View',
              params: { id: data.item.manualShipmentId }
            }">{{ data.item.orderNumber }}</router-link>
          </span>
          <span class="badge badge-info" v-else-if="data.item.type == 'WarehouseShipment'">
            <router-link :to="{
              name: 'Warehouses.WarehouseTransfers.View',
              params: { id: data.item.warehouseShipmentId }
            }">{{ data.item.orderNumber }}</router-link>
          </span>
          <span class="badge badge-info" v-else-if="data.item.type == 'WorkOrder'">
            <router-link :to="{
              name: 'Manufacturing.WorkOrder.Edit',
              params: { id: data.item.workOrderId }
            }">{{ data.item.orderNumber }}</router-link>
          </span>
          <span class="badge badge-info" v-else-if="data.item.type == 'DirectInventoryUpdate'">
            <router-link :to="{
              name: 'Inventory.DIU.View',
              params: { id: data.item.directInventoryUpdateId }
            }">{{ data.item.orderNumber }}</router-link>
          </span>
          <span class="badge badge-secondary" v-else>{{ data.item.orderNumber }}</span>
        </div>
      </template>
      <template v-slot:cell(chargeType)="data">
        <BillingCarrierChargeTypeBadge :chargeType="data.item.chargeType"></BillingCarrierChargeTypeBadge>
      </template>
    </TableListing>
  </section>
</template>

<script>
import ActiveFiltersCard from '@/views/components/ActiveFiltersCard.vue';
import BillingCarrierChargeTypeBadge from '@/views/components/BillingCarrierChargeTypeBadge.vue';
import BillingChargeAmount from '@/views/components/BillingChargeAmount.vue';
import BillingCarrierRelatedInfoBadge from '@/views/components/BillingCarrierRelatedInfoBadge.vue';
import TableListing from '@/views/components/TableListing.vue';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
import carrierBillingEntries from '@/helpers/store/modules/billing/carrierBillingEntries';

export default {
  name: 'Manage.CustomerInvoices.Index',
  mixins: [crudMixinGen('billing/carrierBillingEntries'), myCommonDataMixin],
  components: {
    ActiveFiltersCard,
    TableListing,
    BillingCarrierChargeTypeBadge,
    BillingCarrierRelatedInfoBadge,
    BillingChargeAmount
  },
  computed: {
  },

  data: () => ({
    showEditBillingEntryPopup: false,
    editBillingEntryItem: null,
    typesFilter: [
      {value: 'StorefrontOrder', text: 'Storefront Orders'},
      //{value: 'StorefrontOrderShipment', text: 'Storefront Shipment'},
      {value: 'SmallParcelShipment', text: 'Small Parcel Shipment'},
      {value: 'BulkShipment', text: 'Bulk Shipment'},
      {value: 'DirectInventoryUpdate', text: 'Adjustment Update'},
      {value: 'WarehouseShipment', text: 'Warehouse Shipment'},
      {value: 'WorkOrder', text: 'Work Order'},
      {value: 'OrderReturn', text: 'Order Return'},
      {value: 'NotTrackedExtensivOrder', text: 'OTHER Order'},
      {value: 'Other', text: 'Unknown'},
    ],
    chargeTypeFilter: [
      {value: 'FuelSurcharge', text: 'Fuel Surcharge'},
      {value: 'Freight Charge', text: 'Freight Charge'},
      {value: 'GeneralSurcharge', text: 'General Surcharge'},
      {value: 'ConnectFulfillmentCharge', text: 'Fulfillment Fees (Connect)'},
      {value: 'Unknown', text: 'Other'},
    ],
    fields: [
      { key: 'brandId', label: 'Client', sortable: false },
      { key: 'chargeHandler', label: 'Source', sortable: false },
      { key: 'relatedInfo', label: 'Related Entity', sortable: false },
      { key: 'referenceNumber', label: 'Ref Numbers', sortable: false },
      { key: 'processedOn', label: 'Charged At', sortable: false },
      { key: 'chargeType', label: 'Type', sortable: false },
      { key: 'chargeDescription', label: 'Label', sortable: false },
      { key: 'singleUnitCharge', label: 'Per Unit', sortable: false },
      { key: 'numberOfUnits', label: 'Units', sortable: false },
      { key: 'lineItemTotal', label: 'Total', sortable: false },

      //{ key: 'zoneId', label: 'Zone', sortable: false },
      { key: 'id', label: 'Action', sortable: false }
    ]
  }),
  mounted() {
    let queryHas = this.$route.query;
    if (queryHas) {
      this.resetFormFilters();
      this.formFilters = Object.assign(this.itemsFilters, queryHas);
      this.itemsFilters = Object.assign(this.itemsFilters, queryHas);
    } else {
      this.resetFormFilters();
    }
    this.loadItems();
  },

  methods: {
    IsFilteringRelatedEntity() {
      let matchesFilter = false;
      if (this.formFilters.relatedEntityType && this.formFilters.relatedEntityId) {
        if(this.formFilters.relatedEntityType == 'StorefrontOrder')
          matchesFilter = true;
        else if(this.formFilters.relatedEntityType == 'WorkOrder')
          matchesFilter = true;
        else if(this.formFilters.relatedEntityType == 'SmallParcelShipment')
          matchesFilter = true;
        else if(this.formFilters.relatedEntityType == 'BulkShipment')
          matchesFilter = true;
        else if(this.formFilters.relatedEntityType == 'DirectInventoryUpdate')
          matchesFilter = true;
        else if(this.formFilters.relatedEntityType == 'WarehouseShipment')
          matchesFilter = true;
      }
      return matchesFilter;
    },
    getRelatedEntityUrl() {
      let matchesFilterQuery = {};
      if (this.formFilters.relatedEntityType == 'StorefrontOrder') {
        matchesFilterQuery = {
          orderId: this.formFilters.relatedEntityId,
          type: 'StorefrontOrder'
        };
      }
      else if (this.formFilters.relatedEntityType == 'WorkOrder') {
        matchesFilterQuery = {
          workOrderId: this.formFilters.relatedEntityId,
          type: 'WorkOrder'
        };
      }
      else if (this.formFilters.relatedEntityType == 'SmallParcelShipment') {
        matchesFilterQuery = {
          manualShipmentId: this.formFilters.relatedEntityId,
          type: 'SmallParcelShipment'
        };
      }
      else if (this.formFilters.relatedEntityType == 'BulkShipment') {
        matchesFilterQuery = {
          manualShipmentId: this.formFilters.relatedEntityId,
          type: 'BulkShipment'
        };
      }
      else if (this.formFilters.relatedEntityType == 'DirectInventoryUpdate') {
        matchesFilterQuery = {
          directInventoryUpdateId: this.formFilters.relatedEntityId,
          type: 'DirectInventoryUpdate'
        };
      }
      else if (this.formFilters.relatedEntityType == 'WarehouseShipment') {
        matchesFilterQuery = {
          warehouseShipmentId: this.formFilters.relatedEntityId,
          type: 'WarehouseShipment'
        };
      }
      return {
          name: 'Billing.CustomerBillingLedger.Index',
          query: matchesFilterQuery
        };
    },
    CanEditBillingEntry(item) {
      var externalSyncedTypes = [
        'TPLHandling',
        'TPLAutoCalcStorage',
        'TPLMaterials',
        'TPLPrepaidFreight',
        'TPLThirdPartyFreight',
        'TPLStorage',
        'TPLSpecialCharges',
        'TPLAutoCalcHandling'
      ];
      return externalSyncedTypes.indexOf(item.chargeType) === -1;
    },
    StartEditingBillingCharge(item) {
      this.editBillingEntryItem = item;
      this.showEditBillingEntryPopup = true;
    },
    OnBillingEntrySaved(updatedEntry) {
      if (updatedEntry) {
        var idx = this.items.findIndex(function(a) { return a.id === updatedEntry.id; });
        if (idx !== -1) {
          this.$set(this.items, idx, Object.assign({}, this.items[idx], updatedEntry));
        }
      }
    },
    RevertToReviewSaveItemBrandInvoice(item) {
      setTimeout(() => {
        this.editingLineItemId = '';
        this.$http
          .post('/api/common/brandInvoices/revertAndSaveItem', {
            orderChargeItemId: item.id,
            singleUnitCharge: 0
          })
          .then((resp) => {
            this.items = this.items.filter(a => a.id != item.id);
            if(this.items.length <= 0)
              this.loadItems();
          })
          .catch((err) => {
          })
      }, 200);
    },
    ConfirmAndSaveItemBrandInvoice(item) {
      setTimeout(() => {
        this.editingLineItemId = '';
        this.$http
          .post('/api/common/brandInvoices/confirmAndSaveItem', {
            orderChargeItemId: item.id,
            singleUnitCharge: item.singleUnitCharge,
          })
          .then((resp) => {
            this.items = this.items.filter(a => a.id != item.id);
            if(this.items.length <= 0)
              this.loadItems();
          })
          .catch((err) => {
          })
      }, 200);
    },
    DeleteManualCharge(item) {
      setTimeout(() => {
        this.editingLineItemId = '';
        this.$http
          .post('/api/common/brandInvoices/deleteItem', {
            orderChargeItemId: item.id
          })
          .then((resp) => {
            this.items = this.items.filter(a => a.id != item.id);
            if(this.items.length <= 0)
              this.loadItems();
          })
          .catch((err) => {
          })
      }, 200);
    },
    ReprocessItemBrandInvoice(item) {
      if(!item.brandInvoiceId) {
        this.$swal('Must be part of invoice to be reprocessed!');
        return false;
      }
      this.$http
        .post('/api/common/brandInvoices/resprocessItem/'+item.brandInvoiceId+'/'+item.id)
        .then((resp) => {
          this.$swal('Item queued up to be reprocessed!');
        })
        .catch((err) => {
        })
    }
  }
};
</script>
